import { Link, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Breadcrumbs, Container, PageFade, Reveal } from "../components/site/Motion";
import { findSector } from "../data/sectors";
import { store } from "../lib/api";
import NotFound from "./NotFound";

export default function Metiers() {
  const { sectorSlug } = useParams();
  const sector = findSector(sectorSlug);
  if (!sector) return <NotFound />;
  const I = sector.icon;

  const choose = (job) => {
    store.set("struktiv_selection", { secteur: sector.slug, secteur_label: sector.name, metier: job.slug, metier_label: job.name });
  };

  return (
    <PageFade>
      <section className="relative overflow-hidden wave-bg">
        <img src={sector.cover} alt="" className="absolute inset-y-0 right-0 hidden h-full w-1/2 object-cover opacity-90 [mask-image:linear-gradient(to_left,black_55%,transparent)] lg:block" />
        <Container className="relative py-12 lg:py-20">
          <Breadcrumbs items={[{ label: "Accueil", to: "/" }, { label: "Secteurs", to: "/secteurs" }, { label: sector.name }]} />
          <Reveal className="mt-10 max-w-xl space-y-6">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#650D23] text-[#FFFDFB]"><I className="h-7 w-7" strokeWidth={1.5} /></span>
            <h1 className="text-4xl leading-[1.05] sm:text-5xl lg:text-6xl" data-testid="sector-title">{sector.name}</h1>
            <p className="text-lg text-[#242020]/80">Sélectionnez votre métier pour obtenir des informations adaptées à votre réalité.</p>
          </Reveal>
        </Container>
      </section>
      <Container className="py-12 lg:py-16">
        <ul className="space-y-4" data-testid="job-list">
          {sector.jobs.map((job, i) => (
            <Reveal as="li" key={job.slug} delay={Math.min(i * 0.04, 0.3)}>
              <Link to={`/questionnaire/${sector.slug}/${job.slug}`} onClick={() => choose(job)} data-testid={`job-card-${job.slug}`}
                className="card-soft group flex w-full items-center gap-5 p-2.5 pr-5 text-left sm:gap-7">
                <img src={job.image} alt="" className="h-16 w-24 shrink-0 rounded-xl object-cover sm:h-20 sm:w-40" />
                <span className="flex-1 font-display text-lg sm:text-2xl">{job.name}</span>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#650D23] text-[#FFFDFB] transition-transform group-hover:translate-x-1">
                  <ChevronRight className="h-5 w-5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </ul>
        <Link to="/secteurs" className="mt-10 inline-block text-sm text-[#650D23] underline-offset-4 hover:underline" data-testid="back-to-sectors">← Retour aux secteurs</Link>
      </Container>
    </PageFade>
  );
}
